module.exports = __webpack_public_path__ + "img/sk.sk031f7d1.svg";